import React, { useEffect, useState } from "react";
import { Percent, Save } from "lucide-react";
import { toast } from "sonner";
import client, { apiErr } from "@/lib/api";
import useMeta from "@/lib/useMeta";

export default function AdminCommissions() {
  const meta = useMeta();
  const [commDefault, setCommDefault] = useState(0);
  const [merchants, setMerchants] = useState([]);

  useEffect(() => {
    client.get("/admin/settings").then((r) => setCommDefault(r.data.commission_percent)).catch(() => {});
    client.get("/admin/merchants").then((r) => setMerchants(r.data)).catch(() => {});
  }, []);

  const saveCommDefault = async () => {
    try { await client.put("/admin/settings/commission", { percent: Number(commDefault) || 0 }); toast.success("تم تحديث العمولة العامة"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const setCatComm = async (cid, val) => {
    try { await client.put(`/admin/categories/${cid}/commission`, { percent: val === "" ? null : Number(val) }); toast.success("تم تحديث عمولة التصنيف"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const setMerchComm = async (mid, val) => {
    try { await client.put(`/admin/merchants/${mid}/commission`, { percent: val === "" ? null : Number(val) }); toast.success("تم تحديث عمولة التاجر"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };

  return (
    <div dir="rtl">
      <h2 className="font-head text-[16px] font-bold px-4 pt-5 pb-2 flex items-center gap-1.5"><Percent size={17} style={{ color: "var(--k-gold-deep)" }} /> العمولات</h2>

      {/* General */}
      <div className="rounded-2xl mx-4 p-4 mb-3" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
        <p className="text-[12px] font-bold mb-1">العمولة العامة</p>
        <p className="text-[11.5px] mb-2" style={{ color: "var(--k-ink-soft)" }}>تُخصم من مستحقات التاجر لكل طلب. يمكن تخصيصها حسب التصنيف أو التاجر أدناه.</p>
        <div className="flex gap-2">
          <div className="flex items-center rounded-lg px-3 flex-1" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)" }}>
            <input data-testid="comm-default" type="number" step="0.5" value={commDefault} onChange={(e) => setCommDefault(e.target.value)} className="w-full bg-transparent py-2.5 text-[14px] font-num font-bold outline-none" />
            <span className="text-[13px]" style={{ color: "var(--k-ink-soft)" }}>%</span>
          </div>
          <button data-testid="comm-default-save" onClick={saveCommDefault} className="k-tap px-5 rounded-lg text-white font-bold text-[13px] flex items-center gap-1" style={{ background: "var(--k-ink)" }}><Save size={14} /> حفظ</button>
        </div>
      </div>

      {/* Per category */}
      <h3 className="font-head text-[14px] font-bold px-4 pb-2">مخصّص حسب التصنيف</h3>
      <div className="rounded-2xl mx-4 p-4 mb-3 grid grid-cols-1 md:grid-cols-2 gap-2" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
        {meta.categories.map((c) => (
          <div key={c.id} className="flex items-center gap-2">
            <span className="text-[12px] flex-1">{c.name}</span>
            <div className="flex items-center rounded-lg px-2" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)", width: 110 }}>
              <input data-testid={`comm-cat-${c.id}`} type="number" step="0.5" defaultValue={c.commission_percent ?? ""} placeholder="عام" onBlur={(e) => setCatComm(c.id, e.target.value)} className="w-full bg-transparent py-1.5 text-[12px] font-num outline-none" />
              <span className="text-[11px]" style={{ color: "var(--k-ink-soft)" }}>%</span>
            </div>
          </div>
        ))}
      </div>

      {/* Per merchant */}
      <h3 className="font-head text-[14px] font-bold px-4 pb-2">مخصّص حسب التاجر</h3>
      <div className="rounded-2xl mx-4 p-4 mb-6 grid grid-cols-1 md:grid-cols-2 gap-2" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}>
        {merchants.length === 0 ? <p className="text-[12px]" style={{ color: "var(--k-ink-soft)" }}>لا يوجد تجار.</p> : merchants.map((m) => (
          <div key={m.id} className="flex items-center gap-2">
            <span className="text-[12px] flex-1 truncate">{m.name}</span>
            <div className="flex items-center rounded-lg px-2" style={{ background: "var(--k-paper)", border: "1px solid var(--k-line)", width: 110 }}>
              <input data-testid={`comm-merch-${m.id}`} type="number" step="0.5" defaultValue={m.commission_percent ?? ""} placeholder="عام" onBlur={(e) => setMerchComm(m.id, e.target.value)} className="w-full bg-transparent py-1.5 text-[12px] font-num outline-none" />
              <span className="text-[11px]" style={{ color: "var(--k-ink-soft)" }}>%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
